import Vue from 'vue'
import { format } from 'date-fns'

Vue.filter('toShortTime', function (value, options) {
  if (value == null) return;
  
  let time = value.substring(value.indexOf('T')+1)
  let h = time.substring(0,2);
  let m = time.substring(3,5);
  
  let date = new Date(0,0,0,h,m,0,0)
  let shortTime = format(date, 'h:mma')
  if (options && options.lowercase) {
    shortTime = shortTime.toLowerCase()
  }
  return shortTime
})
